import React, { useEffect } from "react";
import WebAppContainer from "@/components/WebAppContainer/WebAppContainer";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import { useFirstLoader } from "@/store/firstLoaderStore";
import { useServiceType } from "@/utils/hooks/useServiceType";
import classNames from "classnames";
import cls from "./styles.module.scss";
import LoaderLogoByService from "./LoaderLogoByService";

const FirstLoader = ({ isLoading }: { isLoading: boolean }) => {
  const progress = useFirstLoader((s) => s.progress);
  const setProgress = useFirstLoader((s) => s.setProgress);
  const setShowFirstLoader = useFirstLoader((s) => s.setShowFirstLoader);

  const { isSravniDohod } = useServiceType();

  useEffect(() => {
    if (!isLoading) return;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev;
        return prev + Math.random() * 10;
      });
    }, 300);

    return () => clearInterval(interval);
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading) {
      setProgress(100);

      const timeout = setTimeout(() => {
        setShowFirstLoader(false);
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  return (
    <div className={cls.firstLoaderWrapper}>
      <WebAppContainer
        usePadding
        className={classNames(
          cls.firstLoaderContainer,
          isSravniDohod ? cls.bgSrd : cls.bgKef
        )}
      >
        <FlexColumn gap={48}>
          <div className={cls.logoBlock}>
            <LoaderLogoByService />
          </div>
          <div className={cls.progresLine}>
            <div
              className={cls.progresTumb}
              style={{ width: `${progress}%` }}
            />
          </div>
        </FlexColumn>
      </WebAppContainer>
    </div>
  );
};

export default FirstLoader;
